<navigation-blocker-layout [template]="templateRef"></navigation-blocker-layout>

<ng-template #templateRef>
    <div class="fc-signup-request">
        <div class="fc-signup-request-display">
            <div class="fc-signup-request-display-info">
                <div class="fc-signup-request-display-info-details">
                    <div class="fc-signup-request-display-info-fc-logo">
                        <a href="{{ appInfo.link }}" class="">
                            <img src="{{ appInfo.logo.signup }}" alt="{{ appInfo.name }}" />
                        </a>
                    </div>
                    <p class="fc-signup-request-display-info-welcome" *fcMediaWrapper="'desktop'">
                        {{ 'SIGNUP.FORM.WELCOME' | translate }}
                    </p>

                    <ul class="fc-signup-request-display-info-highlights-list" *fcMediaWrapper="'desktop'">
                        <li>
                            <fcp-icon [icon]="['fal', 'check']"></fcp-icon>
                            {{ 'SIGNUP.REQUEST.HIGHLIGHT1' | translate }}
                        </li>
                        <li>
                            <fcp-icon [icon]="['fal', 'check']"></fcp-icon>
                            {{ 'SIGNUP.REQUEST.HIGHLIGHT2' | translate }}
                        </li>
                        <li>
                            <fcp-icon [icon]="['fal', 'check']"></fcp-icon>
                            {{ 'SIGNUP.REQUEST.HIGHLIGHT3' | translate }}
                        </li>
                    </ul>
                </div>
                <div class="fc-signup-request-display-language" [formGroup]="languageForm">
                    <fcp-dropdown [items]="languages" formControlName="lang" [title]="languageForm.value.lang?.label">
                        <fcp-icon [icon]="['fal', 'globe']"></fcp-icon>
                    </fcp-dropdown>
                    <button fcp-button (click)="logout()">
                        <fcp-icon-svg
                            [icon]="iconNameMap.Logout"
                            [size]="fcpIconSVGSize.Small"
                            class="logout-icon"
                        ></fcp-icon-svg>
                        {{ 'NAV_HEADER_LOGOUT' | translate }}
                    </button>
                </div>
            </div>
        </div>
        <div class="fc-signup-request-interactive">
            <router-outlet></router-outlet>
        </div>
    </div>
</ng-template>
